import { css } from "styled-components";
import withMatchMedia from "./with-match-media";

export const breakpoints = {
  //large is desktop/default
  medium: 1023, // just smaller than ipad landscape  
  small: 760, // just smaller than an ipad mini
  tiny: 480 // iphone5
};
// small: 576,

export const breakpointsPx = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = `${breakpoints[label]}px`;
  return acc;
}, {});

export const styledMedia = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakpointsPx[label]}) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});

export const jsQueries = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = `(max-width: ${breakpointsPx[label]})`;
  return acc;
}, {});

export const withMatches = Object.keys(breakpoints).reduce((acc, label) => {
  const propName = "is" + label.charAt(0).toUpperCase() + label.substring(1);
  acc[label] = withMatchMedia(jsQueries[label], propName);
  return acc;
}, {});

export function withAllMatches(Component) {
  return Object.keys(withMatches).reduce(
    (acc, cv) => withMatches[cv](acc),
    Component
  );
}

// media query for larger devices
export const largeMobileMediaQuery = `(orientation: portrait) and (min-width: 768px),
(orientation: landscape) and (min-width: 1024px)`;

export const styledLargeMobileMediaQuery = args => css`
  @media ${largeMobileMediaQuery} {
    ${css(args)};
  }
`;
